import { apiClient, ApiName } from '@shared/services/api'

export const fetchGiftCards = () => {
  return apiClient.get(ApiName.ADMINS, 'super/giftCards/pending')
}

export const createGiftCardVoucher = (id, data) => {
  return apiClient.post(ApiName.ADMINS, `super/giftCards/${id}/voucher`, data)
}
